import { Pipe, PipeTransform } from '@angular/core';

interface DataUriImage {
  imageBase64: string;
  contentType: string;
}

/**
 * Transforms an image object with base64 data into a data URI string.
 *
 * Usage:
 *   [src]="image | dataUri"
 *   [src]="currentImage() | dataUri"
 *
 * Example output:
 *   data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg==
 */
@Pipe({
  name: 'dataUri',
  standalone: true,
})
export class DataUriPipe implements PipeTransform {
  /**
   * Transforms a satellite image into a data URI string.
   * @param image The satellite image with contentType and imageBase64 properties
   * @returns A data URI string suitable for use in src attributes
   */
  transform(image: DataUriImage | null | undefined): string {
    if (!image) {
      return '';
    }
    return `data:${image.contentType};base64,${image.imageBase64}`;
  }
}
